'use client';

import Link from 'next/link';
import { AppImage } from '@impacta/shared';
import { AppIcon } from '@impacta/shared';

export default function GiftingSection() {
  return (
    <section id="gifting" className="py-20 bg-[#FAFAF8]">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Image side */}
          <div className="relative">
            <Link href="/regalar" className="block">
              <div className="relative rounded-3xl overflow-hidden aspect-[4/3]">
                <AppImage
                  src="/assets/images/homepage/gifting.jpg"
                  alt="Manos sosteniendo y entregando una caja de regalo envuelta con lazo"
                  fill
                  className="object-cover"
                  sizes="(max-width: 1024px) 100vw, 50vw"
                />

                <div
                  className="absolute inset-0"
                  style={{
                    background: 'linear-gradient(135deg, rgba(0,161,155,0.15) 0%, transparent 60%)',
                  }}
                />
              </div>
            </Link>
            {/* Floating card */}
            <div className="absolute -bottom-4 -right-4 bg-white rounded-2xl p-5 shadow-panel max-w-[220px]">
              <div className="flex items-center gap-3 mb-2">
                <div
                  className="w-10 h-10 rounded-xl flex items-center justify-center"
                  style={{ backgroundColor: '#e6f7f6' }}
                >
                  <AppIcon name="GiftIcon" size={20} className="text-[#00A19B]" />
                </div>
                <div>
                  <p className="text-xs text-[#6b6e68]">Tarjeta regalo</p>
                  {/* TODO: Linkear con el valor minimo existent para tarjetas */}
                  <p className="text-sm font-bold text-[#373A36]">Desde $10.000</p>
                </div>
              </div>
              <p className="text-xs text-[#6b6e68]">
                Válida para cualquier taller de la plataforma.
              </p>
            </div>
          </div>

          {/* Content side */}
          <div>
            <p className="section-label mb-3">Regala una experiencia</p>
            <h2 className="section-title mb-5">El mejor regalo es aprender algo nuevo juntos.</h2>
            <p className="text-[#6b6e68] text-base leading-relaxed mb-6">
              Regala una tarjeta de experiencia IMPACTA.red y deja que quien la recibe elija la
              actividad que más le inspire. Válida por 12 meses, sin restricciones de categoría.
            </p>

            {/* Features */}
            <ul className="space-y-4 mb-8">
              {[
                { icon: 'CheckCircleIcon', text: 'Entrega inmediata por correo electrónico' },
                {
                  icon: 'CheckCircleIcon',
                  text: 'Válida para todas las actividades de la plataforma',
                },
                // TODO: Linkear con el valor minimo y maximo existent para tarjetas
                { icon: 'CheckCircleIcon', text: 'Montos desde $10.000 hasta $50.000 CLP' },
                { icon: 'CheckCircleIcon', text: 'Canjeable hasta 12 meses desde la compra' },
              ].map((item) => (
                <li key={item.text} className="flex items-start gap-3">
                  <AppIcon
                    name={item.icon as any}
                    size={20}
                    className="text-[#00A19B] mt-0.5 flex-shrink-0"
                    variant="solid"
                  />
                  <span className="text-sm text-[#373A36] font-medium">{item.text}</span>
                </li>
              ))}
            </ul>

            <Link
              href="/regalar#giftcards"
              className="inline-flex items-center gap-2 px-8 py-4 rounded-full font-bold text-base transition-all duration-200 bg-[#E0DF00] text-[#373A36] hover:bg-[#00A19B] hover:text-white"
            >
              <AppIcon name="GiftIcon" size={18} />
              Regalar una experiencia
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
